import {
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
  IonLoading,
  IonPage,
} from '@ionic/react';
import { useCallback, useContext, useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { AppContext } from '../../../lib/context/AppContext';
import { ITrip, Trip } from '../../../lib/models';
import Banner from '../../../components/Banner';
import Toolbar from '../../../components/Toolbar';
import TripCard from './TripCard';

const TripsList: React.FC = (props) => {
  const { apiService } = useContext(AppContext);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [haveNewItemsToLoad, setHaveNewItemsToLoad] = useState(true);
  const [trips, setTrips]: [ITrip[], any] = useState([]);
  let [pagination, setPagination] = useState({ start: 0, limit: 20 });

  const getTrips = useCallback(
    (pagination: any) => {
      apiService
        ?.get(
          `/trips?populate=media&sort=id:desc&pagination[start]=${pagination.start}&pagination[limit]=${pagination.limit}`
        )
        .then((response: any) => {
          setIsPageLoading(false);
          setHaveNewItemsToLoad(response.data?.data?.length >= 10);

          setTrips([
            ...trips,
            ...response.data.data.map((_trip: any) => Trip(_trip)),
          ]);
        });
    },
    [apiService, trips]
  );

  useEffect(() => {
    setIsPageLoading(true);
    setTrips([]);
    getTrips(pagination);
  }, [apiService]);

  return (
    <>
      <IonPage>
        <IonHeader>
          <Toolbar title='Viaggi'></Toolbar>
        </IonHeader>

        <IonContent fullscreen>
          <IonLoading spinner='bubbles' isOpen={isPageLoading} />
          <PageContainer>
            {trips.length === 0 && !isPageLoading && (
              <Banner
                title=''
                message='Nessuna viaggio presente'
                className='mt-8'
              />
            )}
            {trips && (
              <>
                <IonList>
                  {trips?.map((trip: ITrip) => (
                    <TripCard key={trip.id} trip={trip}></TripCard>
                  ))}
                </IonList>
                {haveNewItemsToLoad && (
                  <IonInfiniteScroll
                    onIonInfinite={(ev) => {
                      pagination = {
                        ...pagination,
                        start: pagination.start + pagination.limit,
                      };
                      setPagination(pagination);
                      getTrips(pagination);
                      setTimeout(() => ev.target.complete(), 500);
                    }}
                  >
                    <IonInfiniteScrollContent></IonInfiniteScrollContent>
                  </IonInfiniteScroll>
                )}
              </>
            )}
          </PageContainer>
        </IonContent>
      </IonPage>
    </>
  );
};

export default TripsList;
